"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenreTargetsResponseToJSON = exports.GenreTargetsResponseFromJSONTyped = exports.GenreTargetsResponseFromJSON = exports.instanceOfGenreTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var TargetBase_1 = require("./TargetBase");
/**
 * Check if a given object implements the GenreTargetsResponse interface.
 */
function instanceOfGenreTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGenreTargetsResponse = instanceOfGenreTargetsResponse;
function GenreTargetsResponseFromJSON(json) {
    return GenreTargetsResponseFromJSONTyped(json, false);
}
exports.GenreTargetsResponseFromJSON = GenreTargetsResponseFromJSON;
function GenreTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'genres': !(0, runtime_1.exists)(json, 'genres') ? undefined : (json['genres'].map(TargetBase_1.TargetBaseFromJSON)),
    };
}
exports.GenreTargetsResponseFromJSONTyped = GenreTargetsResponseFromJSONTyped;
function GenreTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'genres': value.genres === undefined ? undefined : (value.genres.map(TargetBase_1.TargetBaseToJSON)),
    };
}
exports.GenreTargetsResponseToJSON = GenreTargetsResponseToJSON;
